webpackJsonp([263791100135453],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        margin: '0 auto',
	        maxWidth: 600
	      }
	    },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'About'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Hi! I\'m Chris and I\'m a web developer. I live in Denver and work with a variety of clients as a freelance consultant. I specialize in the front end and find myself working on a lot of Wordpress projects. I spend some of my free time learning and experimenting with technologies and languages like react, python, node, bash, and gatsby.js.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When I\'m not doing dev things, I enjoy playing guitar, playing video games, reading, riding my bicycle, and taking in the outdoors. I also really enjoy craft beer and live music. And frisbee golf.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you need a new website or need to redesign an old one, get in touch with me. I\'m also available for various maintenance work as well as web emergencies.'
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-705c5af37848aa50c8f0.js